import * as React from 'react';
import {Navigation} from "./navigation";
import {HeaderLogo} from "./header-logo";
import {Footer} from "./footer";
import './aside-navigation.scss'
type IProps = {
  showCategory: (e: number) => void
  currentCategory: number
};

export const AsideNavigation = ({showCategory, currentCategory}: IProps) =>  {
    return (
      <div className="view-nav">
        <HeaderLogo />
        <Navigation showCategory={showCategory} currentCategory={currentCategory} />
        <Footer copyright={"Метрорадио ЕООД"}/>
      </div>
    );
};
